export default "__VITE_ASSET__GZ1BK2kB__"